export const packageInfo = [
    {
        id: 1,
        packageTitle: 'Standart',
        price: 60_000,
        list: [
            'Ինքնուսուցում, որից հետո միանգամից հասանելիություն եք ստանում բոլոր 12 դասերին և օգտակար հղումներին',
            'Սերտիֆիկատ՝ մասնակցության',
            'Հասանելիություն դասերին 3-6 ամիս',
            'Պատրաստի ռեզյումեի օրինակի ստացում',
        ]
    },
    {
        id: 2,
        packageTitle: 'Premium',
        price: 110_000,
        list: [
            'Տևողությունը 1 ամիս',
            'Շաբաթական 2-3 դաս, որոնք կտեղադրվեն google disk-ում',
            'Յուրաքանչյուր շաբաթ հարց-պատասխան ֆորմատով հանդիպում zoom-ով',
            '1 ամիս Mpstats վերլուծական գործիքով և վաճառողի էջով պրակտիկա',
            'Սերտիֆիկատ, որը կփաստի ձեր վաճառքի մասնագետ լինելը',
            '1 տարի հետադարձ կապ',
            'Բոնուս դաս, որտեղ կուսուցանվի աշխատաշուկա մտնելու առաջին ճիշտ քայերը և ձեր անձնային բրենդը ստեղծելու ճիշտ քայլերը',
            'Ընդհանուր տելեգրամյան խմբի հասանելիություն',
            'Անհատական մոտեցում',
            'Պատրաստի ռեզյումեի օրինակի ստացում'
        ]
    },
    {
        id: 3,
        packageTitle: 'Pro',
        price: 140_000,
        list: [
            'Տևողությունը 1 ամիս',
            {important:'Շաբաթական 2-3 դաս, որոնք կկայանան zoom-ով (ուղիղ միացում), իսկ ամեն դասի վերջում հարց-պատասխան քննարկում'},
            '1 ամիս Mpstats վերլուծական գործիքով և վաճառողի էջով պրակտիկա',
            'Սերտիֆիկատ, որը կփաստի ձեր վաճառքի մասնագետ լինելը',
            '1 տարի հետադարձ կապ',
            'Ընդհանուր տելեգրամյան խմբի հասանելիություն',
            'Անհատական մոտեցում',
            'Բոնուս դաս, որտեղ կուսուցանվի աշխատաշուկա մտնելու առաջին ճիշտ քայերը և ձեր անձնային բրենդը ստեղծելու ճիշտ քայլերը։',
            {important: 'Աշխատանքի տեղավորման աջակցություն պրակտիկայի շրջանակներում գերազանց ստացած ուսանողներին(3-6 ամսվա ընթացքում)'},
            'Պատրաստի ռեզյումեի օրինակի ստացում'
        ]
    },
    {
        id: 4,
        packageTitle: 'VIP',
        subTitle: '(Անհատական)',
        price: 400_000,
        list: [
            'Տևողությունը 1 ամիս',
            'Շաբաթական 2-3 դաս, որոնք կանցկացվեն zoom ֆորմատով և ժամերը կհարմարեցվեն ձեզ հետ',
            '1 ամիս Mpstats վերլուծական գործիքով և վաճառողի էջով պրակտիկա',
            'Բոնուս դաս, որտեղ կուսուցանվի աշխատաշուկա մտնելու առաջին ճիշտ քայերը և ձեր անձնային բրենդը ստեղծելու ճիշտ քայլերը։',
            'Սերտիֆիկատ, որը կփաստի ձեր մասնագետ լինելը',
            'Ընդհանուր տելեգրամյան խմբի հասանելիություն',
            'Անհատական մոտեցում',
            '1 ամիս ձեզ հետ զուգահեռ աշխատանք՝ անհրաժեշտության դեպքում',
            '1 տարի հետադարձ կապ',
            'Պատրաստի ռեզյումեի օրինակի ստացում'
        ]
    },
]

export const sideBarInfo =
    [
        {name: 'Գլխավոր էջ', link: '/'},
        {name: 'Իմ մասին', link: '/about'},
        {name: 'Վաճառքներ', link: '/sales'},
        {name: 'Կարծիքներ', link: '/opinion'},
    ]

export const topics = [
    "Մենեջեր, սելլեր մասնագիտությունների ընդհանրական ներկայացում և աշխատանքի կազմակերպման ընթացակարգի ուսումնասիրություն",
    "Խանութի Գրանցում, անհրաժեշտ փաստաթղթերի ուսումնասիրություն, честный знак",
    "Անալիտիկ գործիքների հետ խորքային աշխատանք",
    "Ապրանքի գրագետ ընտրություն՝ հիմնված նիշայի, շուկայի և մրցակիցների վերլուծության վրա և այն հարմարեցնելով Ձեր բյուջեին",
    "SEO օպտիմիզացիա",
    "Քարտի ստեղծում և ինֆոգրաֆիկա",
    "Ապրանքի Փաթեթավորում, պիտակավորում և լոգիստիկա",
    "Դեպի պահեստներ մատակարարման կազմակերպում",
    "Հաճախորդների և աջակցման կենտրոնի հետ կապի պահպանում",
    "Արժեքներ, զեղչեր և գնային քաղաքականություն",
    "Ներքին և արտաքին գովազդների կառավարում",
    "Խորքային ալգորիթմների ուսումնասիրում",
    "Ինքնագնում, գնագոյացում",
    "Աշխատանք գտնելու հարթակների տրամադրում",
    "Նձնային բրենդի ստեղծում և զարգացում",
    "Չինական շուկայի հետ աշխատանքի ուսումնասիրում և մատչելի մատակարարների հետ կապի ստեղծում։"
];

export const trainingDescription = [
    "Ապրանքի ընտրություն՝ ըստ ցանկացած բյուջեի",
    "Վաճառող քարտ",
    "Seo-ի ճիշտ կազմում և նրա հետ տարվող աշխատանք",
    "Գնային քաղաքականություն և ակցիաների գրագետ մասնակցություն՝ ի շահ մեր մարժայի",
    "Գովազդի գրագետ կառավարում",
    "Բոնուս նվեր՝ Ձեր գործող քարտի աուդիտ",
];

export const whyWb = [
    "WB-ն ԱՊՀ տարածքի խոշորագույն մարքեթփլեյս է, որը ունի միլիոնավոր հաճախորդների հասանելիություն։ Եթե ցանկանում եք արագ զարգացնել ձեր ապրանքանիշը, բարձրացնել վաճառքները և դուրս գալ նոր շուկաներ՝ սա ձեր լավագույն շանսն է և այս շանսը Ձեզ թույլ կտա ամսեկան ունենալ 1մլն և ավելի եկամուտ՝ աշխատելով օրեկան 2-3 ժամ։",
    "Եթե դու ունես նորաստեղծ բռենդ ՀՀ-ում, բայց ուզում ես ընդլայնել բռենդիդ մասշտաբները, սա քո համար իրական հնարավորություն է, քանի որ կունենաս բռենդի զարգացում միջազգային հարթակում։",
    "Եթե անգամ չես ցանկանում վաճառել, ապա կարող ես աշխատել որպես մենեջեր, օրեկան աշխատանքիդ տրամադրել 2-3 ժամ, աշխատել մինչև 5-10 գործատուի հետ, և վաստակել ամսեկան միջինում սկսած 200.000 դրամից, և որ ամենակարևորն է աշխատել ազատ և ճկուն գրաֆիկով՝ համատեղելով ցանկացած զբաղվածության հետ։"
]

export const forWhom = [
    'Արտադրողների',
    'Վերավաճառողների',
    'Ուսանողների',
    'Դեկրետի մայրիկների',
    'Եվ պարզապես նրանց համար, ովքեր ցանկանում են ընդամենը 1 ամսում ձեռք բերել հեռանկարային և շատ եկամտաբեր նոր մասնագիտություն'
]

export const whyThisCourse = [
    "Այս դասընթացը ընտրելով դու հայտնվում ես ապահով ձեռքերում, ստանում ես հիմնավոր ու շատ խորքային գիտելիքներ, որոնց շնորհիվ կրկնակի ուսուցման անհրաժեշտություն չես ունենում, ինչը շուկայում այսօր տարածված երևույթ է։",
    "Սովորում ես ուսուցանող մասնագետի ու մյուսների սխալների վրա, այլ ոչ թե քո։",
    "Քեզ հետ աշխատելու է 3 տարվա փորձ, գիտելիքների մեծ պաշար ունեցող մասնագետը, ով այս տարիների ընթացքում ացել է մի շարք կուրսեր, վերապատրաստումներ և սեմինարներ (Լեո Շևչենկո, rashid_kimm, оракул, Անտոն Լանցով, Կրիստինա Տարբա, Անդրեյ Կատոկ)",
    "Դու սովորելու ես ստեղծել քո աճող բիզնեսը ամենամեծ օնլայն շուկաներից մեկում, որտեղ վաճառք ունի վաճառողների միայն 15-25%, իսկ այս դասընթացը օգնելու է քեզ դասվես այդ փոքրամասնության շարքին։",
    "Ունենալու ես 1 տարի հետադարձ կապ անձամբ Միլենա Մելիքսեթյան կողմից։",
    "Դասերին հասանելիություն կունենաս 6-9 ամիս։",
    "Յուրաքանչյուր ուսանող ստանում է անհատական մոտեցում Միլենա Մելիքսեթյանի կողմից։",
    "Լավ արդյունքներ ունենալու դեպքում դուք կներգրավվեք Միլենա Մելիքսեթյանի թիմում՝ նրանից ստանալով մի շարք աշխատանքային առաջարկներ։",
    "Դու ստանում ես հնարավորություն ստանալ մշտական թարմացվող ինֆորմացիայի։"
]

export const lecturer = [
    "Հեղինակային դասընթաց, հիմնադիր՝ Միլենա Մելիքսեթյան, հիմնված փորձի, ձախողումների և շատ խորքային գիտելիքների վրա։",
    "Արդեն 3 տարի ոլորտում։",
    "Սեփական խանութով ամսեկան 20 մլն-ի շրջանառություն ապահովող։",
    "Բիզնես խոսնակ։",
    "Թվով 6 մեծամասշտաբ մաստեր կլասսներ իրականացրած։",
    "900+ գոհ ուսանող։"
];

export const accordionDataFaq = [
    { id: 1, title: 'Սա ի՞նչ մասնագիտություն է և ինչ ենք սովորելու և աշխատելու', content: 'Այն Wildberries-ը, որից օգտվում ենք գրեթե բոլոր, կարող ենք նաև ոչ միայն այստեղ գումար ծախսել, այլ նաև վաստակել։\n' +
            'Wildberries-ը մարկետփլեյս է, այնպիսին ինչպիսին Amazon, Taobao, Temu, Shein և այլն։\n' +
            'Դուք սովորելու եք WB-ում վաճառքի իրականացման և բիզնեսի հիմնման ողջ հմտությունները ու գաղտնիքները, որից հետո կարող եք ինչպես Ձեր խանութը բացել WB-ում, այնպես էլ շատ այլ խանութներում աշխատել որպես մենեջեր։' },
    { id: 2, title: 'Ի՞նչ է անում մենեջերը', content: 'Մենեջերը այն մասնագետն է, ով իր աշխատանքով օգնում է բիզնեսին մուտք գործել Wildberries միջազգային շուկա և օգնում է կազմակերպել վաճառքները։ Մենեջերը վաճառքի ողջ գործընթացը կազմակերպող և վերահսկողն է։' },
    { id: 3, title: 'Ի՞նչ ձևաչափով է անցնում դասը, կարո՞ղ եմ այլ երկրից մասնակցել, և հետագայում աշխատել', content: 'Դասընթացը անցնում է օնլայն ձևաչափով, բոլոր դասերը՝ անկախ ընտրված դասընթացի փաթեթից տեսաձայնագրվում են, որը Ձեզ հնարավորություն է տալիս դասերը նայել Ձեզ հարմար ժամի և վայրից։' },
    { id: 4, title: 'Լեզուների իմացություն պետք է՞', content: 'Ո՛չ, լեզուների խորքային իմացություն պետք չէ' },
    { id: 5, title: 'Կարո՞ղ եմ համատեղել այլ զբաղվածության հետ', content: 'Այո, եթե ունեք օրեկան 2-3 ժամ ազատ ժամանակ, որը կարող եք տրամադրել նոր մասնագիտությանը, ապա կարող եք' },
    { id: 6, title: 'Ինձ մոտ կստացվի՞', content: 'Իհարկե ամեն ինչ կախված է Ձեր պոտենցիալից, աշխատասիրությունից, բայց դասընթացը շատ ֆունդոմենտալ է, սովորելու եք 0-ից մինչև վաճառքի կազմակերպման ամենախորքային հնարքները։ Եվ այս դասընթացը անցնելու համար նախնական փորձ ու գիտելիք պետք չէ' },
    { id: 7, title: 'Այս մասնագիտությունը ձեռք բերելուց հետո՝ Ձեր եկամուտը', content: [
            "Մենեջեր – սկսած 100,000 դրամ",
            "Սելլեր – սկսած 500,000 դրամ",
            "Խորհրդատվություն – 20,000 դրամ",
            "Ապրանքի ընտրություն – 20,000 դրամ",
            "Շուկայի և մրցակիցների վերլուծություն – 20,000–50,000 դրամ",
            "SEO – 20,000 դրամ",
            "Ամբողջական քարտի կազմում – 40,000 դրամ",
            "Ինֆոգրաֆիկա – 15,000 դրամ",
            "Ապրանքի նկարահանում – 15,000 դրամ",
            "Ֆուլֆիլմենթ – սկսած 20,000 դրամից",
            "Հաշվապահական հաշվառում – 15,000 դրամ",
            "Վերլուծաբանություն և վիճակագրություն – 20,000 դրամ",
            "Գովազդի կառավարում – 30,000 դրամ",
            "Ռազմավարության մշակում – 50,000 դրամ",
            "Քարտի վերանայում – 20,000 դրամ",
            "Ինքնագնումների կազմակերպում – 20,000 դրամ",
            "Unit Economic հաշվարկ – 10,000 դրամ"
        ]
    },
];
